import { apiGet, type RequestOptions } from './index'

export interface ShowClockAuditEvent {
  id: number
  station_id: number
  day_id: number
  item_id: number | null
  user_id: number | null
  action: string
  ts_epoch: number
  details: unknown
  created_at: string | null
}

export interface ShowClockAuditResponse {
  events: ShowClockAuditEvent[]
  next_cursor: string | null
  request_id?: string
}

export const getShowClockDayAudit = async (
  params: { stationId: number; dayId: number; limit?: number; cursor?: string | null },
  options?: RequestOptions,
): Promise<ShowClockAuditResponse> => {
  const search = new URLSearchParams({ station_id: String(params.stationId), day_id: String(params.dayId) })
  if (params.limit) {
    search.set('limit', String(params.limit))
  }
  if (params.cursor) {
    search.set('cursor', params.cursor)
  }
  return apiGet<ShowClockAuditResponse>(`showclock/day/${params.dayId}/audit?${search.toString()}`, options)
}
